import { render } from "./plannedTrainingDetail.vue?vue&type=template&id=24869c57&scoped=true&ts=true"
import script from "./plannedTrainingDetail.vue?vue&type=script&lang=ts"
export * from "./plannedTrainingDetail.vue?vue&type=script&lang=ts"

import "./plannedTrainingDetail.vue?vue&type=style&index=0&id=24869c57&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24869c57"]])

export default __exports__